import React from 'react';
import { Button, Divider, Segment, Header } from 'semantic-ui-react';
import { ButtonLink } from '@emyw/auth-lib';
import PlanDetail, { getCost } from '../PlanDetail';
import PaymentDetail from '../PaymentDetail';
// import PromotionCode from '../PromotionCode';
import '../custom-theme.css';
import PromotionCode from '../PromotionCode';
var ConfirmDetailsForm = function ConfirmDetailsForm(_ref) {
  var onTermsClick = _ref.onTermsClick,
    onPrivacyClick = _ref.onPrivacyClick,
    onChangePlanClick = _ref.onChangePlanClick,
    onEditPaymentClick = _ref.onEditPaymentClick,
    onComplete = _ref.onComplete,
    user = _ref.user,
    processing = _ref.processing,
    monthlyCostMessage = _ref.monthlyCostMessage,
    planSelectDisabled = _ref.planSelectDisabled,
    darkMode = _ref.darkMode,
    defaultPromoCode = _ref.defaultPromoCode,
    onValidatedPromoCode = _ref.onValidatedPromoCode,
    onInvalidPromoCode = _ref.onInvalidPromoCode,
    onCodeRemoved = _ref.onCodeRemoved,
    loadUser = _ref.loadUser,
    context = _ref.context;
  var _ref2 = user || {},
    paymentMethod = _ref2.paymentMethod;
  if (user.subscriptionLevelCode === 'FREE' && window.location.pathname.indexOf('signup') > -1) paymentMethod = null;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'left'
    }
  }, user && /*#__PURE__*/React.createElement(Segment, {
    className: "subscriptionSummary",
    size: "mini",
    attached: !planSelectDisabled || paymentMethod ? 'top' : false,
    secondary: true,
    style: {
      textAlign: 'left'
    }
  }, /*#__PURE__*/React.createElement(Header, {
    className: "subscribeDetailSummary lighter"
  }, /*#__PURE__*/React.createElement("div", null, user.email), planSelectDisabled && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, "".concat(getCost(user), "/month")), monthlyCostMessage || ''))), !planSelectDisabled && /*#__PURE__*/React.createElement(PlanDetail, {
    onChangePlanClick: onChangePlanClick,
    user: user,
    attached: paymentMethod ? true : user ? 'bottom' : false,
    secondary: true,
    monthlyCostMessage: monthlyCostMessage
  }), paymentMethod && /*#__PURE__*/React.createElement(PaymentDetail, {
    onEditPaymentClick: onEditPaymentClick,
    user: user,
    attached: "bottom",
    secondary: true,
    darkMode: darkMode
  })), /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  }), /*#__PURE__*/React.createElement(PromotionCode, {
    user: user,
    defaultPromoCode: defaultPromoCode,
    onValidatedPromoCode: onValidatedPromoCode,
    onInvalidPromoCode: onInvalidPromoCode
    // onCodeRemoved={onCodeRemoved}
    ,
    darkMode: darkMode,
    loadUser: loadUser,
    context: context
  }), /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  }), /*#__PURE__*/React.createElement("div", {
    className: "confirmMsg"
  }, "By clicking the \"Start Membership\" button below, you agree to our\xA0", /*#__PURE__*/React.createElement(ButtonLink, {
    onClick: onTermsClick
  }, "Terms of Use"), "\xA0and\xA0", /*#__PURE__*/React.createElement(ButtonLink, {
    onClick: onPrivacyClick
  }, "Privacy Policy"), "\xA0and that you are over 18. You may cancel at any time. To cancel, go online to your Account and change your plan to the \"Free Plan\".", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("b", null, "If remaining on the paid plan after the free trial, Enjoy will automatically continue your membership and charge any membership fee (currently ", user.subscriptionLevelMonthlyCostFormatted, /*#__PURE__*/React.createElement("sup", null, "*"), " plus any applicable sales tax) to your payment method on a monthly basis until you cancel by switching to the Free plan."), /*#__PURE__*/React.createElement("br", null), "There are no refunds or credits for partial months."), /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  }), /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    size: "large",
    primary: true,
    fluid: true,
    loading: processing,
    style: {
      margin: '0px auto',
      maxWidth: '300px'
    },
    onClick: onComplete
  }, "START MEMBERSHIP"));
};
ConfirmDetailsForm.defaultProps = {
  monthlyCostMessage: null,
  planSelectDisabled: false,
  darkMode: false
};
export default ConfirmDetailsForm;